import React, {useEffect } from 'react';
const HomePage = () => {
    useEffect(() => {
        document.body.classList = "saleMain";
    }, []);
    return (
        <div>
        </div>

    )

}

export default HomePage;